import React, { useEffect, useState } from "react";
import CustomerChatTable from "modules/customer_chats/CustomerChatTable";
import { Button } from "react-bootstrap";
import customerChatUseStore from "modules/customer_chats/store";
import xlsx from "json-as-xlsx";
import moment from "moment";
import PaginationDiv from "modules/pagination/PaginationDiv";
import CloudIcon from "assets/svgs/cloud_icon";
import CardDiv from "modules/common/card-div/CardDiv";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function CustomerChat() {
  const {
    chatData,
    chatDownload,
    countPage,
    chatLoading,
    error,
    fetchChatData,
    fetchCount,
    fetchDownloadData,
  } = customerChatUseStore();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const pageData = searchParams.get("pageNumber");
  const [page, newPage] = useState(1);
  const [sortedData, setSortedData] = useState([]);

  useEffect(() => {
    navigate(`/customerChats?pageNumber=${page}`);
  }, [page]);

  useEffect(() => {
    newPage(Number(pageData));
  }, []);

  useEffect(() => {
    setSortedData([
      ...chatDownload?.sort(
        (a, b) => moment(b?.createdAt) - moment(a?.createdAt)
      ),
    ]);
  }, [chatDownload]);

  useEffect(() => {
    fetchChatData(pageData);
    fetchDownloadData();
    fetchCount();
    navigate(`/customerChats?pageNumber=${pageData}`);
  }, [pageData]);

  const downloadData = () => {
    const _data = sortedData.map((el) => {
      let sender = "";
      if (el && el.chat_meta && el.chat_meta.actor && el.chat_meta.actor.type) {
        sender += el.chat_meta.actor.type;
      }
      if (sender.length > 0) sender += " | ";
      if (el && el.chat_meta && el.chat_meta.actor && el.chat_meta.actor.name) {
        sender += el.chat_meta.actor.name;
      }
      if (
        el &&
        el.chat_meta &&
        el.chat_meta.actor &&
        el.chat_meta.actor.first_name
      ) {
        sender += el.chat_meta.actor.first_name;
      }
      return {
        ...el,
        createdAt: moment(el.createdAt).format("YYYY/MM/DD HH:mm:ss"),
        sender: sender,
        customer: el.user ? el.user[0].first_name : "",
      };
    });

    const data = [
      {
        sheet: "Customer Chats",
        columns: [
          { label: "Customer Name", value: "customer" },
          { label: "Type", value: "direction" },
          { label: "Sender", value: "sender" },
          { label: "Created at", value: "createdAt" },
        ],
        content: _data,
      },
    ];

    let settings = {
      fileName: "Customer chats",
      extraLength: 3,
      writeMode: "writeFile",
      writeOptions: {},
    };

    xlsx(data, settings);
  };

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between">
          <div className="fs-2">Customer Chat</div>
          <div className=" text-end">
            <Button
              type="primary"
              onClick={downloadData}
              size="medium"
              className=""
              disabled={!chatDownload || chatDownload?.length === 0}
            >
              <CloudIcon /> Download
            </Button>
          </div>
        </div>
      }
      component={
        <div className="mb-5 w-100">
          <CustomerChatTable
            tableData={chatData}
            isLoading={chatLoading}
            error={error}
          />
          <PaginationDiv
            paginationData={{
              pageCount: countPage ? Math.ceil(countPage / 10) : 1,
              page: page,
            }}
            newPage={newPage}
          />
        </div>
      }
    />
  );
}

export default CustomerChat;
